export default function ({ store, app, redirect }) {
  const hasAction = store.state.redirectUrl
  if (hasAction !== '') {
    if (process.server) return redirect(app.localePath(hasAction))
    app.router.push(app.localePath(hasAction))
    store.commit('SET_RETURN_URL', app.localePath(hasAction))
  }
}
